// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bar {
  height: 40px;
  width: 2px;
  background-color: orange;
}

.specimenInfo {
  font-family: montserrat;
}

.back_color {
  background-color: #007887;
  color: white;
}

.text-warning {
  color: #f0ad4e !important;
}

.success_border {
  border-radius: 3px;
  border-left: 5px solid green;
  border-bottom: 1px solid green;
  border-top: 1px solid green;
  border-right: 1px solid green;
  font-size: 11px;
  cursor: pointer;
}

.warning_border {
  border-radius: 3px;
  border-left: 5px solid #f0ad4e;
  border-bottom: 1px solid #f0ad4e;
  border-top: 1px solid #f0ad4e;
  border-right: 1px solid #f0ad4e;
  font-size: 11px;
  cursor: pointer;
}

.notes {
  font-size: 11px;
  color: #19727f;
  font-weight: 500;
}

.lables_style {
  font-size: 10px !important;
  color: #001C3B;
  font-weight: 500;
  padding: 3px;
}

.specimentinfo_main {
  overflow-x: hidden;
  height: 70vh;
}

.site_font {
  font-size: 9px !important;
}

.sequence_font {
  font-size: 20px !important;
}

.site_producers_font {
  font-size: 13px !important;
  color: #17a0b4 !important;
}

.gross_description {
  font-size: 11px !important;
}

.micrographs_lable {
  font-weight: 800 !important;
  font-size: 11px !important;
  display: block !important;
  margin-bottom: 3px !important;
}

.pending_procedure {
  font-weight: 800;
  font-size: 11px;
}

.overflowx_casespecimen {
  overflow-x: hidden;
}

.notsendout {
  font-size: 12px;
  width: 100%;
  left: 6%;
  position: relative;
}

::ng-deep.sendoutdata.mat-mdc-menu-panel {
  overflow-x: hidden !important;
  min-width: 218px !important;
  padding-inline: 9px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/case360/casespecimen/casespecimen.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,UAAA;EACA,wBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAGA;EACE,yBAAA;EACA,YAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,4BAAA;EACE,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,eAAA;EACA,eAAA;AAAJ;;AAEA;EACE,kBAAA;EACA,8BAAA;EACE,gCAAA;EACA,6BAAA;EACA,+BAAA;EACA,eAAA;EACA,eAAA;AACJ;;AAGA;EACE,eAAA;EAAgB,cAAA;EAAe,gBAAA;AAEjC;;AACA;EACE,0BAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;AAEF;;AAEA;EACA,kBAAA;EACA,YAAA;AACA;;AAEA;EACE,yBAAA;AACF;;AACA;EACE,0BAAA;AAEF;;AACA;EACE,0BAAA;EACU,yBAAA;AAEZ;;AACA;EACE,0BAAA;AAEF;;AACA;EACE,2BAAA;EAA4B,0BAAA;EAA2B,yBAAA;EAA0B,6BAAA;AAKnF;;AAFA;EACE,gBAAA;EAAiB,eAAA;AAMnB;;AAFA;EACE,kBAAA;AAKF;;AAFA;EACE,eAAA;EACE,WAAA;EACA,QAAA;EACA,kBAAA;AAKJ;;AAHA;EACE,6BAAA;EACA,2BAAA;EACA,8BAAA;AAMF","sourcesContent":[".bar{\r\n  height: 40px;\r\n  width: 2px;\r\n  background-color: orange;\r\n}\r\n\r\n.specimenInfo{\r\n  font-family: montserrat;\r\n}\r\n\r\n\r\n.back_color{\r\n  background-color: #007887;\r\n  color: white;\r\n}\r\n\r\n.text-warning {\r\n  color: #f0ad4e !important;\r\n}\r\n\r\n.success_border{\r\n  border-radius: 3px;\r\n  border-left: 5px solid green;\r\n    border-bottom: 1px solid green;\r\n    border-top: 1px solid green;\r\n    border-right: 1px solid green;\r\n    font-size: 11px;\r\n    cursor: pointer;\r\n}\r\n.warning_border{\r\n  border-radius: 3px;\r\n  border-left: 5px solid #f0ad4e;\r\n    border-bottom: 1px solid #f0ad4e;\r\n    border-top: 1px solid #f0ad4e;\r\n    border-right: 1px solid #f0ad4e;\r\n    font-size: 11px;\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n.notes{\r\n  font-size: 11px;color: #19727f;font-weight: 500;\r\n}\r\n\r\n.lables_style{\r\n  font-size: 10px !important;\r\n  color: #001C3B;\r\n  font-weight: 500;\r\n  padding: 3px;\r\n}\r\n\r\n\r\n.specimentinfo_main{\r\noverflow-x: hidden;\r\nheight: 70vh;\r\n}\r\n\r\n.site_font{\r\n  font-size: 9px !important;\r\n}\r\n.sequence_font{\r\n  font-size: 20px !important;\r\n}\r\n\r\n.site_producers_font{\r\n  font-size: 13px !important;\r\n            color: #17a0b4 !important;\r\n}\r\n\r\n.gross_description{\r\n  font-size: 11px !important;\r\n}\r\n\r\n.micrographs_lable{\r\n  font-weight: 800 !important;font-size: 11px !important;display: block !important;margin-bottom: 3px !important;\r\n}\r\n\r\n.pending_procedure{\r\n  font-weight: 800;font-size: 11px;\r\n}\r\n\r\n\r\n.overflowx_casespecimen{\r\n  overflow-x: hidden;\r\n}\r\n\r\n.notsendout{\r\n  font-size: 12px;\r\n    width: 100%;\r\n    left: 6%;\r\n    position: relative;\r\n}\r\n::ng-deep.sendoutdata.mat-mdc-menu-panel {\r\n  overflow-x: hidden !important;\r\n  min-width: 218px !important;\r\n  padding-inline: 9px !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
